// Raw Data Ticket

// {
//   "success": true,
//   "id": "64a279d27102bc51188948f6",
//   "order_ids": [
//       "001561491121"
//   ],
//   "title": "Senior Tactics Planner",
//   "description": "Non autem porro et cupiditate voluptas nam ut. Est sed quis aliquid. Aut eveniet rerum et praesentium ratione. Ipsum doloribus aut exercitationem molestias.",
//   "reference_id": "1Hws92CKDBpzhCEYhQppKDS8XSNVg",
//   "reporter_contact_name": "Vena",
//   "reporter_contact_phone": "730-704-9267",
//   "support_image_links": [
//       "https://biteship.s3.ap-southeast-1.amazonaws.com/public/images/biteship/email_shipping_tools_header.png"
//   ],
//   "is_read_by_user": true,
//   "type": "address_changed",
//   "channel": "biteship",
//   "status": "active",
//   "comments": [],
//   "created_by": "self",
//   "created_at": "2023-07-03T07:33:38.657Z",
//   "processed_at": null,
//   "solved_at": null
// },

export const APItoData = (tickets) => {
  return tickets.map((i) => ({
    id: i.id,
    title: i.title,
    type: i.type,
    status: i.status,
    isReadByUser: i.is_read_by_user,
    createdAt: i.created_at,
  }));
};

export const singleAPItoData = (i) => {
  return {
    id: i.id,
    title: i.title,
    orderIds: i.order_ids,
    description: i.description,
    type: i.type,
    status: i.status,
    comments: i.comments
      .map((j) => ({
        content: j.content,
        self: j.self,
        updatedAt: j.updated_at,
        userFirstName: j.user_first_name,
        userLastName: j.user_last_name,
        userRole: j.user_role,
      }))
      .reverse(),
    supportImageLinks: i.support_image_links,
    isReadByUser: i.is_read_by_user,
    createdAt: i.created_at,
  };
};
